import React from "react";
import AddGenusSpeciality from "./components/AddGenusSpeciality";

const AddGenusSpecialityContainer=()=><AddGenusSpeciality/>

export default AddGenusSpecialityContainer;